export const ADD_RECENT_HISTORY = 'ADD_RECENT_HISTORY';

export type RecentHistoryAction = {
  type: string;
  newRecent: {
    QID: string;
    name: string;
  }
}
